/**
 * The one ERP table density. Every data table — the shared `Table` and the few hand-built
 * ones — uses these, so rows are the same height on every page: a 30px column-header row
 * and 36px body rows.
 *
 * Cell height is fixed and vertical padding is zero, so a row holding a badge, a button or
 * a small input is exactly as tall as a text-only row. Width is left to the content: a wide
 * table scrolls sideways rather than changing its row height.
 */
export const TH_DENSITY = 'h-[30px] px-2 py-0 text-[10px] sm:text-[11px]';

export const TD_DENSITY =
  'h-9 px-2 py-0 text-xs sm:text-[13px] sm:leading-5 ' +
  // Slim the controls inside a row so they never push it past the standard height.
  '[&_button]:!py-0.5 [&_button]:!leading-4 [&_button]:align-middle ' +
  '[&_span.rounded-full.border]:align-middle [&_span.rounded-full.border]:leading-4 ' +
  '[&_input:not([type=checkbox]):not([type=radio])]:!h-7 [&_input:not([type=checkbox]):not([type=radio])]:!py-0 ' +
  '[&_select]:!h-7 [&_select]:!py-0 ' +
  // Stacked text stays inside the row; chip/button groups never wrap onto a second line.
  '[&_div]:leading-4 [&_.flex-wrap]:flex-nowrap';

/** Title bar above a table (title, count, column picker, export). */
export const TABLE_BAR_DENSITY = 'min-h-[40px] px-3 py-1 sm:px-4';
